const RecordProblem = resolve =>require(['@/components/admin/RecordProblem.vue'], resolve)

export default {
    path: '/appadmin/recordProblem',
    component: RecordProblem,
    meta: {
        title: '录题',
        path:'/appadmin/recordProblem',
    breadList: [
      {
        title: '资源管理',
        path: '/appadmin/recordProblem'
      },
      {
        title: '录题',
        path:'/appadmin/recordProblem'
      }]
    },
}



// WEBPACK FOOTER //
// ./src/router/admin/recordProblem.js